export default __webpack_public_path__ + "static/media/darkChocolate.5004f0d8.jpg";